import React, { useState } from 'react';
import { i18nIntl, isNotEmpty } from '../../lib/ep';
import { injectIntl } from 'react-intl';

import Input from '../builder/Input';
import Model from '../builder/Model';
import SaveButton from '../builder/SaveButton';
import LeveledHTMLText from './helpers/LeveledHTMLText';

const ProtectedPromo = (props) => {
	const [ data, setData ] = useState({ password:"" });
	const [ errors, setErrors ] = useState({});

	const promotion = props?.promotion?.Promotion ?? false;
	if(promotion === false) return null;

	const l = props?.l ?? {};

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const change = (k, v) => {
		setErrors({});
		setData({ [k]:v });
	};

	const send = (cb) => {
		if(data.password == "") {
			setErrors({ password:"Please, enter a password" });
			if(cb != undefined) cb();
			return;
		}

		$.post(window.location.href, { code:data.password }, (result) => {
			if(cb != undefined) cb();
			if(result.result == 'valid') {
				self.location.href = result?.rurl ?? `/p/${promotion.id}`;
			} else {
				setErrors({ password:"The password is not valid" });
			}
		}, 'JSON');
	}

	const description_placeholder = `<h1>${i18n("Enter the password to access the promotion")}</h1>`;

	return (
		<div class="flex_cols">
			<div class="flex_col col_2">
				<LeveledHTMLText
					_class={{ other:'gui_main_text_color_on_bg' }}
				>{(isNotEmpty(promotion, 'password_desc')) ? promotion.password_desc : description_placeholder}</LeveledHTMLText>

				<div class={`${l?.register_form?.class ?? ''} register_form_flex`}>
					<div class="form_register template_module">
						<div class="gui_main_text_color_on_bg gui_not_in_top_big">
							<Model model={data} change={change} errors={errors}>
								<Input
									name="password"
									_type='password'
									_class={{ first:true }}
								>Password</Input>
							</Model>
						</div>
					</div>

					<div class={`${l?.call_to_action?.class ?? ''} template_module register_call_to_action_flex`}>
						<div class="finalize_form enter flex_button gui_big_button">
							<SaveButton
								_fullclass=""
								onClick={(e, cb) => send(cb)}
							>Enter</SaveButton>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default injectIntl(ProtectedPromo);